import { ContentState } from "draft-js";
import { ExerciseType } from "@domain/lms/course/exercise/exercise";
import { ExerciseDraft } from "@domain/lms/course/exercise/exerciseDraft";
import { withId } from "@utils/domain";

export class ExerciseController {
	constructor(
		private readonly exerciseUpdater: (update: (exercise: ExerciseDraft) => ExerciseDraft) => void,
		readonly removeExercise: () => void
	) {}

	setExerciseInfo(exerciseUpdate: Partial<ExerciseDraft>): void {
		this.exerciseUpdater((ex) => ({ ...ex, ...exerciseUpdate }));
	}

	setTitle(title: string): void {
		this.setExerciseInfo({ title });
	}

	setComment(comment: ContentState): void {
		this.setExerciseInfo({ comment });
	}

	addChoice(): void {
		this.exerciseUpdater((current) => ({
			...current,
			choices: current.choices.push(withId({ text: "", valid: false })),
		}));
	}

	removeChoice(index: number): void {
		this.exerciseUpdater((current) => ({
			...current,
			choices: current.choices.delete(index),
		}));
	}

	setChoiceText(index: number, text: string): void {
		this.exerciseUpdater((current) => ({
			...current,
			choices: current.choices.update(index, (choice) => ({ ...choice, text })),
		}));
	}

	setChoiceValid(index: number): void {
		this.exerciseUpdater((current) => ({
			...current,
			choices: current.choices
				.map((choice) => ({ ...choice, valid: choice.valid }))
				.update(index, (choice) => ({ ...choice, valid: !choice.valid })),
		}));
	}

	toggleEditing(): void {
		this.exerciseUpdater((current) => ({ ...current, editing: !current.editing }));
	}

	setType(type: ExerciseType): void {
		this.exerciseUpdater((current) => ({ ...current, type }));
	}
}
